// ============================================================================
//  CONTENUTI DEL SITO — UNICO FILE DA MODIFICARE PER AGGIORNARE IL SITO
// ----------------------------------------------------------------------------
//  • FOTO: sostituisci i file in /public/images/ mantenendo lo stesso nome
//    (hero.jpg, mestre.jpg, padova.jpg, santangelo.jpg, assistenza.jpg,
//    conto-online.jpg) oppure cambia qui il percorso.
//  • TELEFONI / WHATSAPP / ORARI / INDIRIZZI: modifica i campi delle sedi.
//  • Per aggiungere una NUOVA SEDE: copia un blocco dentro STORES, cambia i
//    dati e aggiungi la rotta in App.js (una riga).
//  • PROMOZIONI: aggiungi oggetti dentro PROMOTIONS quando autorizzate.
//  • GUIDA: aggiungi passaggi dentro GUIDE_STEPS quando pronta.
//  • TESTI LEGALI: compila LEGAL_PAGES con i testi definitivi.
// ============================================================================

// Link autorizzato per l'apertura del conto gioco online
export const REGISTRATION_LINK =
  "https://sgc.sisal.it/srvpartner/partnershipRedirect?pid=507&camid=1&cliid=&affid=PD6594";

// WhatsApp assistenza (usato nella pagina Conto Online)
export const ASSISTANCE_WHATSAPP = "393343391284";
export const ASSISTANCE_WHATSAPP_DISPLAY = "+39 334 339 1284";

// WhatsApp per dubbi durante la registrazione (Passaggio 2 — Conto Online)
export const GUIDE_WHATSAPP = "393494681343";
export const GUIDE_WHATSAPP_DISPLAY = "+39 349 468 1343";

// --------------------------------------------------------------------------
//  LE SEDI
// --------------------------------------------------------------------------
export const STORES = [
  {
    id: "mestre",
    slug: "/mestre",
    name: "Sisal Store Mestre",
    shortName: "Mestre",
    address: "Via Giuseppe Mazzini 6/A",
    city: "Mestre – Venezia",
    fullAddress: "Via Giuseppe Mazzini 6/A, 30171 Mestre (VE)",
    mapQuery: "Via Giuseppe Mazzini 6, 30171 Mestre VE",
    phoneDisplay: "041 200 6494",
    phoneTel: "+390412006494",
    whatsapp: "393316394404",
    whatsappDisplay: "331 639 4404",
    hoursSummary: "Tutti i giorni · 9:45 – 23:00",
    hours: [{ label: "Lunedì – Domenica", value: "9:45 – 23:00" }],
    open247: false,
    image: "/images/mestre.jpg",
    imagePosition: "center 30%",
    description:
      "Il nostro punto vendita di Mestre, a due passi dal centro: un ambiente moderno e accogliente dove il nostro staff è a disposizione per assisterti su tutti i servizi, dalle scommesse sportive all'apertura del conto gioco.",
    services: ["sport", "ippica", "conto", "assistenza", "slot", "virtual", "superenalotto"],
    gallery: [], // aggiungi qui altre foto della sala, es: "/images/mestre-sala-1.jpg"
  },
  {
    id: "padova",
    slug: "/padova",
    name: "Sisal Store Padova",
    shortName: "Padova",
    address: "Via Pilade Bronzetti 14",
    city: "Padova",
    fullAddress: "Via Pilade Bronzetti 14, 35138 Padova (PD)",
    mapQuery: "Via Pilade Bronzetti 14, 35138 Padova PD",
    phoneDisplay: "049 872 6687",
    phoneTel: "+390498726687",
    whatsapp: null, // WhatsApp non ancora disponibile: inserisci qui il numero (es. "393331234567")
    whatsappDisplay: null,
    hoursSummary: "Tutti i giorni · 9:00 – 23:00",
    hours: [{ label: "Lunedì – Domenica", value: "9:00 – 23:00" }],
    open247: false,
    image: "/images/padova.jpg",
    description:
      "La nostra sede di Padova: ampi spazi, terminali veloci e personale preparato per seguirti in ogni operazione. Aperti tutti i giorni fino a sera, anche nei weekend.",
    services: ["sport", "ippica", "conto", "assistenza", "virtual", "slot", "vlt", "superenalotto"],
    gallery: ["/images/padova-sala-1.jpg"],
  },
  {
    id: "santangelo",
    slug: "/santangelo",
    name: "Sisal Store Sant'Angelo di Piove di Sacco",
    shortName: "Sant'Angelo di Piove di Sacco",
    address: "Viale Leonardo Da Vinci 1",
    city: "Sant'Angelo di Piove di Sacco – Padova",
    fullAddress: "Viale Leonardo Da Vinci 1, 35020 Sant'Angelo di Piove di Sacco (PD)",
    mapQuery: "Viale Leonardo da Vinci 1, 35020 Sant'Angelo di Piove di Sacco PD",
    phoneDisplay: "+39 334 339 1284",
    phoneTel: "+393343391284",
    whatsapp: "393343391284",
    whatsappDisplay: "+39 334 339 1284",
    hoursSummary: "Aperto 24 ore su 24 · 7 giorni su 7",
    hours: [{ label: "Lunedì – Domenica", value: "Aperto 24 ore su 24" }],
    open247: true,
    image: "/images/santangelo.jpg",
    imagePosition: "center 22%",
    description:
      "Il Sisal Store di Sant'Angelo di Piove di Sacco è aperto 24 ore su 24, sette giorni su sette: trovi sempre qualcuno pronto ad aiutarti, a qualsiasi ora del giorno e della notte.",
    services: ["sport", "ippica", "conto", "assistenza", "virtual", "slot", "vlt", "superenalotto", "bar", "maxischermo"],
    gallery: [],
  },
];

// --------------------------------------------------------------------------
//  I SERVIZI (mostrati in home e nella pagina /servizi)
// --------------------------------------------------------------------------
export const SERVICES = [
  {
    id: "sport",
    icon: "Trophy",
    title: "Scommesse Sportive",
    desc: "Calcio, basket, tennis e tutti i principali sport: gioca la tua schedina con il supporto del nostro staff.",
  },
  {
    id: "ippica",
    icon: "Medal",
    title: "Ippica",
    desc: "Le corse dei principali ippodromi, nazionali e internazionali, in un ambiente dedicato.",
  },
  {
    id: "slot-vlt",
    icon: "Dices",
    title: "Slot/VLT",
    desc: "Slot e VLT di ultima generazione in un ambiente moderno, accogliente e controllato.",
  },
  {
    id: "eventi",
    icon: "Tv",
    title: "Eventi Sportivi",
    desc: "Segui i grandi eventi sportivi in diretta sui nostri schermi, in compagnia di altri appassionati.",
  },
  {
    id: "conto",
    icon: "UserPlus",
    title: "Apertura Conto Gioco",
    desc: "Ti aiutiamo ad aprire e ricaricare il tuo conto gioco, in sede o guidandoti passo passo online.",
  },
  {
    id: "assistenza",
    icon: "HeartHandshake",
    title: "Assistenza",
    desc: "Personale disponibile per informazioni, supporto e risposte chiare su tutti i servizi.",
    catalog: false,
  },
  // Servizi specifici per sede (non mostrati nella griglia generale)
  { id: "slot", icon: "Dices", title: "Slot", desc: "", catalog: false },
  { id: "virtual", icon: "MonitorPlay", title: "Virtual", desc: "Lo sport virtuale sempre disponibile: eventi simulati da seguire e giocare a ogni ora del giorno." },
  { id: "superenalotto", icon: "Star", title: "SuperEnalotto", desc: "", catalog: false },
  { id: "vlt", icon: "Monitor", title: "VLT", desc: "", catalog: false },
  { id: "bar", icon: "Coffee", title: "Bar", desc: "", catalog: false },
  { id: "maxischermo", icon: "Tv", title: "Maxischermo", desc: "", catalog: false },
];

// --------------------------------------------------------------------------
//  PROMOZIONI — nessuna promozione inventata: aggiungile qui solo quando
//  autorizzate. Esempio di struttura pronta all'uso:
//  {
//    title: "Titolo promozione",
//    description: "Breve descrizione",
//    conditions: "Condizioni e termini",
//    validity: "Valida dal ... al ...",
//    image: "/images/promo-1.jpg",
//    link: "https://...",
//  }
// --------------------------------------------------------------------------
export const PROMOTIONS = [];

// --------------------------------------------------------------------------
//  GUIDA APERTURA CONTO — inserisci qui i passaggi quando la guida è pronta
//  { title: "Passaggio 1 — ...", text: "...", image: "/images/guida-1.jpg" }
// --------------------------------------------------------------------------
export const GUIDE_STEPS = [];

// --------------------------------------------------------------------------
//  PAGINE LEGALI — PLACEHOLDER: sostituisci con i testi definitivi
// --------------------------------------------------------------------------
export const LEGAL_PAGES = {
  privacy: {
    slug: "/privacy",
    title: "Privacy Policy",
    placeholder:
      "[PLACEHOLDER — TESTO DA INSERIRE] Informativa privacy ai sensi del Regolamento (UE) 2016/679. Il testo definitivo verrà fornito e pubblicato in questa pagina.",
  },
  "cookie-policy": {
    slug: "/cookie-policy",
    title: "Cookie Policy",
    placeholder:
      "[PLACEHOLDER — TESTO DA INSERIRE] Questo sito utilizza cookie tecnici necessari al funzionamento. La mappa di Google Maps viene caricata solo dopo il tuo consenso. Il testo definitivo della Cookie Policy verrà pubblicato in questa pagina.",
  },
  "gioco-responsabile": {
    slug: "/gioco-responsabile",
    title: "Gioco Responsabile",
    placeholder:
      "[PLACEHOLDER — TESTO DA INSERIRE] Il gioco è vietato ai minori di 18 anni e può causare dipendenza patologica. Il testo definitivo sul gioco responsabile verrà pubblicato in questa pagina.",
  },
  "note-legali": {
    slug: "/note-legali",
    title: "Informazioni Legali",
    placeholder:
      "[PLACEHOLDER — TESTO DA INSERIRE] Informazioni societarie, autorizzazioni e diciture obbligatorie. I contenuti definitivi verranno pubblicati in questa pagina.",
  },
};

// --------------------------------------------------------------------------
//  HELPER
// --------------------------------------------------------------------------
export const waLink = (number, text) =>
  `https://wa.me/${number}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const mapsLink = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

export const getStore = (id) => STORES.find((s) => s.id === id);
